import * as React from 'react';

import type {CoreEntityType} from 'nutshell-core/types';

import {LeadTwoLine} from 'shells/lead/lead-two-line';
import {PeepTwoLine} from 'shells/peep/peep-two-line';

import {useGetSessionUser} from '../../../core/use-get-session-user';

type Props = {
    cellData: any;
    isLoading: boolean;
    entityType: CoreEntityType | null | undefined;
};

export function NameCellContent(props: Props) {
    const {user} = useGetSessionUser();

    if (props.entityType === 'leads') {
        return (
            <LeadTwoLine
                avatarUrl={props.cellData.avatarUrl}
                htmlUrl={props.cellData.htmlUrl}
                isLinkable={Boolean(user && user.permissions.canAccessCrm)}
                leadName={props.cellData.primaryName}
                leadNumber={props.cellData.primaryInfo}
                priority={props.cellData.priority}
                relatedCompany={props.cellData.primaryAccount}
                relatedPerson={props.cellData.primaryContact}
                isLoading={props.isLoading}
                // This is a mess, but our map data doesn't include
                // status, so we need to check to make sure we're
                // not working with that kind of data
                leadStatus={
                    props.cellData.fields &&
                    props.cellData.fields.status &&
                    props.cellData.fields.status.value
                        ? props.cellData.fields.status.value.value
                        : ''
                }
            />
        );
    } else {
        return (
            <PeepTwoLine
                name={props.cellData.primaryName}
                avatarUrl={props.cellData.avatarUrl}
                initials={props.cellData.initials}
                htmlUrl={props.cellData.htmlUrl}
                isLinkable={Boolean(user && user.permissions.canAccessCrm)}
                type={props.entityType}
                shouldClientRoute={true}
                relatedEntityName={props.cellData.relatedName}
                isLoading={props.isLoading}
                shouldCenterAlignSingleRow={true}
            />
        );
    }
}
